import { render } from "./PageIndexTwo.vue?vue&type=template&id=4122cd7d"
import script from "./PageIndexTwo.vue?vue&type=script&lang=js"
export * from "./PageIndexTwo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__